import { render, staticRenderFns } from "./nshop-order-item-pins.vue?vue&type=template&id=5675846e&scoped=true&"
import script from "./nshop-order-item-pins.vue?vue&type=script&lang=js&"
export * from "./nshop-order-item-pins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675846e",
  null
  
)

export default component.exports